function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.478,0a.686.686,0,0,0-.7.667v.667H2.7a.768.768,0,0,0-.444.12A.6.6,0,0,0,2,1.931V15.348a.647.647,0,0,0,.185.461A.687.687,0,0,0,2.667,16H17.333a.687.687,0,0,0,.482-.191A.647.647,0,0,0,18,15.348V1.931a.6.6,0,0,0-.251-.478.768.768,0,0,0-.444-.12H15.217V.667a.686.686,0,0,0-.7-.667h-.7a.686.686,0,0,0-.7.667v.667H6.87V.667A.686.686,0,0,0,6.174,0Zm0,.667h.7v2h-.7Zm8.348,0h.7v2h-.7ZM2.7,2H4.783v.667a.686.686,0,0,0,.7.667h.7a.686.686,0,0,0,.7-.667V2H13.13v.667a.686.686,0,0,0,.7.667h.7a.686.686,0,0,0,.7-.667V2H17.3V4.333H2.7Zm0,3H17.3V15.333H2.7Z",
  transform: "translate(-2)"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default ForwardRef;